import React, {useState} from 'react'

interface HelpVideoModalProps {
  videoName?: string // örnek: 'DersDegerlendirmeAnlatimVideosu'
  videoExtension?: string
  videoPath?: string
  buttonClassName?: string
}

const API_URL = process.env.REACT_APP_API_URL

const HelpVideoModal: React.FC<HelpVideoModalProps> = ({
  videoName,
  videoExtension,
  videoPath,
  buttonClassName = 'btn btn-secondary ms-auto',
}) => {
  const [show, setShow] = useState(false)

  if (!API_URL) return null

  const baseUrl = API_URL.slice(0, -4) // 'api' kısmını kaldır

  const normalizedExtension = (videoExtension ?? 'mov').replace(/^\.+/, '')

  const resolvedPath = videoPath
    ? videoPath.startsWith('/')
      ? videoPath.substring(1)
      : videoPath
    : videoName
    ? `Files/Guides/${videoName}.${normalizedExtension}`
    : null

  if (!resolvedPath) {
    return null
  }

  const videoUrl = `${baseUrl}${resolvedPath}`

  return (
    <>
      <button className={buttonClassName} onClick={() => setShow(true)}>
        📹 Yardım / Eğitim Videosu
      </button>

      {show && (
        <div
          className='modal show d-block'
          tabIndex={-1}
          role='dialog'
          style={{backgroundColor: 'rgba(0,0,0,0.5)'}}
        >
          <div className='modal-dialog modal-lg modal-dialog-centered' role='document'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title'>🎥 Eğitim Videosu</h5>
                <button type='button' className='btn-close' onClick={() => setShow(false)}></button>
              </div>
              <div className='modal-body text-center'>
                <video controls autoPlay width='100%' preload='metadata'>
                  <source src={videoUrl} type='video/mp4' />
                  Tarayıcınız video oynatmayı desteklemiyor.
                </video>
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-secondary' onClick={() => setShow(false)}>
                  Kapat
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default HelpVideoModal
